var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loader)?_c('div',{staticClass:"pag-loader"},[_c('v-progress-circular',{attrs:{"size":70,"width":7,"color":"primary","indeterminate":"","id":"loading"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }